import styles from './styles';

import * as React from 'react';

import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';

import type { OnlineServiceCategory } from 'tm3-core/api.dtos';

import type SearchStore from 'connect/web/src/stores/search-store';
import { SearchType } from 'connect/web/src/stores/search-store';

import CardMedia from '../../../card-media';

import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';

import { withStyles } from '@material-ui/core';
import { AnalyticsEvents } from 'connect/core/enums/analytics-enum';
import type ProviderStore from 'src/stores/provider-store';

interface IProps extends WithStyles<typeof styles> {
  category: OnlineServiceCategory;

  searchStore?: SearchStore;

  onClick: (category: OnlineServiceCategory) => void;
  providerStore: ProviderStore;
}

@inject('searchStore', 'providerStore')
@observer
class CategoryCard extends React.Component<IProps> {
  render() {
    if (!this.show) {
      return null;
    }

    const { classes, category } = this.props;
    const { title, description, imageUrl } = category;
    const { mode } = this.props.searchStore!;

    return (
      <div className={classes.root}>
        <Card className={classes.card} onClick={this.onClick}>
          <CardActionArea className={classes.actionArea}>
            <div className={classes.content}>
              <CardMedia imageUrl={imageUrl} />
              <CardContent>
                <Typography component="h1" color="primary">
                  {title}
                </Typography>
                <Typography>{description}</Typography>
              </CardContent>
            </div>
          </CardActionArea>
        </Card>
      </div>
    );
  }

  @computed
  private get show(): boolean {
    const { searchStore, category } = this.props;
    const { hasClasses, hasAppointments } = category;
    const { mode } = searchStore!;

    return (
      mode === SearchType.Initial ||
      (mode === SearchType.Appointment && hasAppointments) ||
      (mode === SearchType.Class && hasClasses)
    );
  }

  @action.bound
  private onClick(): void {
    const { category, onClick, providerStore } = this.props;
    onClick(category);

    providerStore!.sendAnalyticsEvent(AnalyticsEvents.CategorySelected, {
      value: category.title
    });
  }
}

export default withStyles(styles)(CategoryCard);
